<template>
  <div class="skeleton-loader">
    <div v-if="type === 'card'" class="skeleton-card">
      <div class="skeleton-body">
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
      </div>
    </div>
    <div v-else-if="type === 'chart'" class="skeleton-chart">
      <div class="skeleton-header"></div>
      <div class="skeleton-chart-body"></div>
    </div>
    <div v-else-if="type === 'list'" class="skeleton-list">
      <div class="skeleton-header"></div>
      <div class="skeleton-list-body">
        <div v-for="i in 5" :key="i" class="skeleton-list-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    type: {
      type: String,
      default: 'card',
      validator: value => ['card', 'chart', 'list'].includes(value)
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.6;
  }
}

.skeleton-loader {
  width: 100%;

  .skeleton-header,
  .skeleton-line,
  .skeleton-chart-body,
  .skeleton-list-item {
    background-color: #e0e0e0;
    border-radius: 4px;
    animation: pulse 1.5s infinite ease-in-out;
  }

  .skeleton-card,
  .skeleton-chart,
  .skeleton-list {
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    height: 100%;
  }

  .skeleton-header {
    height: 24px;
    width: 60%;
    margin-bottom: 16px;
  }

  .skeleton-line {
    height: 16px;
    width: 100%;
    margin-bottom: 8px;

    &:last-child {
      width: 80%;
    }
  }

  .skeleton-chart-body {
    height: 250px;
    width: 100%;
  }

  .skeleton-list-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .skeleton-list-item {
    height: 24px;
    width: 100%;
  }

  body.dark-layout & {
    .skeleton-header,
    .skeleton-line,
    .skeleton-chart-body,
    .skeleton-list-item {
      background-color: #3b4253;
    }

    .skeleton-card,
    .skeleton-chart,
    .skeleton-list {
      background-color: #283046;
    }
  }
}
</style>
